import React, { useContext } from 'react'
import styled, { keyframes } from 'styled-components'
import useLocalStorage from 'react-use/lib/useLocalStorage'
import { highestZIndex } from 'shared/css/z-indexes'
import UserContext from 'shared/components/context/user'

const slideIn = keyframes`
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(57px);
    }
`
const InnerContainer = styled.div`
    text-align: left;
    width: 1040px;
    min-width: 1040px;
    color: white;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 0.21px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const ProductName = styled.span`
    font-size: 20px;
    font-weight: 900;
`

const Banner = styled.div`
    width: 100%;
    position: absolute;
    top: -57px;
    left: 0;
    height: 57px;
    background: linear-gradient(-135deg, rgb(255, 102, 102) 0%, rgb(97, 87, 255) 100%);
    z-index: ${highestZIndex};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: 0.3s ${slideIn} ease-out;
    animation-delay: 1.5s;
    animation-fill-mode: forwards;
`

const CloseButton = styled.div`
    mask-image: url(/static/img/close.svg);
    background-color: white;
    position: absolute;
    right: 10px;
    // is desktop check was here;
    top: 15px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
`

const BetaPill = styled.img`
    position: relative;
    display: inline-block;
    margin: 0px 11px;
    height: 26px;
`

const Emoji = styled.span`
    position: relative;
    font-size: 20px;
    margin-right: 3px;
`

const LeftContent = styled.div`
    display: flex;
    align-items: center;
`

const slideInForCTA = `(max-width: 1100px)`
const RightContent = styled.div`
    @media ${slideInForCTA} {
        transform: translateX(-70px);
        transition: transform 300ms ease-out;
    }
`

const RightArrow = styled.div`
    display: inline;
    position: relative;
    top: 3px;
`

const SuperCutMessage = () => {
    const { user, isLoggedIn } = useContext(UserContext)
    const [hasSeenBanner, setHasSeenBanner] = useLocalStorage(`has-seen-super-cut-banner`, false)

    const hide = () => {
        setHasSeenBanner(true)
    }

    if (!hasSeenBanner && isLoggedIn && (user.isStaff || user.permissions.access_dvr)) {
        return (
            <Banner>
                <InnerContainer>
                    <LeftContent>
                        <Emoji>👋</Emoji> <ProductName>GIPHY Super Cut</ProductName>
                        <BetaPill src="/static/img/svg/pill-new.svg" alt="" /> Bulk GIF creation, super easy.{' '}
                    </LeftContent>
                    <RightContent>
                        <a onClick={hide} href={'/supercut/'}>
                            Open Super Cut <RightArrow className="ss-icon ss-navigateright" />
                        </a>
                    </RightContent>
                </InnerContainer>
                <CloseButton onClick={hide} />
            </Banner>
        )
    } else {
        return null
    }
}

export default SuperCutMessage
